export interface Comic {
  id: string;
  title: string;
  category: string;
  categoryKey: string;
  author: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  cover: string;
  description: string;
  tags: string[];
  chapters: number;
  likes: number;
}

export interface Category {
  key: string;
  name: string;
  desc: string;
  icon: string;
}

export const categories: Category[] = [
  { key: 'love', name: '爱情漫画', desc: '心动瞬间与甜蜜纠葛，细腻刻画每一段青春心事。', icon: 'ri-heart-3-line' },
  { key: 'fantasy', name: '奇幻漫画', desc: '魔法、异世界与神秘力量，开启天马行空的冒险旅程。', icon: 'ri-sparkling-2-line' },
  { key: 'action', name: '动作漫画', desc: '热血战斗与极限对抗，拳拳到肉的燃爽体验。', icon: 'ri-fire-line' },
  { key: 'campus', name: '校园漫画', desc: '青春校园与少年心气，记录成长中的笑与泪。', icon: 'ri-graduation-cap-line' },
  { key: 'mystery', name: '悬疑漫画', desc: '层层反转与烧脑谜团，跟随线索揭开真相。', icon: 'ri-magic-line' },
];

export const comics: Comic[] = [
  {
    id: 'moonsealed-contract',
    title: '月光下的契约',
    category: '奇幻',
    categoryKey: 'fantasy',
    author: '金多贤',
    status: '连载中',
    rating: 9.4,
    views: '1286万',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20Korean%20manhwa%20cover%2C%20a%20young%20man%20in%20an%20elegant%20dark%20coat%20standing%20under%20a%20glowing%20crescent%20moon%2C%20soft%20ethereal%20blue%20magical%20light%20particles%2C%20romantic%20fantasy%20mood%2C%20clean%20dreamy%20gradient%20background%2C%20high%20detail%20digital%20painting%2C%20portrait%20composition&width=480&height=640&seq=cover-moon-01&orientation=portrait',
    description: '月圆之夜，落魄的大学生韩志远捡到一枚刻着古老符文的银戒，从此被卷入跨越千年的神魔契约。守护月之力的神秘女子、暗藏秘密的宗门、以及渐渐苏醒的禁忌之力……他必须在爱与使命之间做出选择。',
    tags: ['魔法', '契约', '罗曼史', '神魔'],
    chapters: 132,
    likes: 98234,
  },
  {
    id: 'heartbeat-store',
    title: '心跳便利店',
    category: '爱情',
    categoryKey: 'love',
    author: '朴彩英',
    status: '连载中',
    rating: 9.1,
    views: '986万',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20anime%20Korean%20manhwa%20cover%2C%20a%20warm%20neighborhood%20convenience%20store%20at%20dusk%20with%20soft%20glowing%20lights%2C%20a%20shy%20boy%20and%20girl%20near%20the%20counter%2C%20sweet%20romantic%20slice%20of%20life%20atmosphere%2C%20cozy%20cream%20and%20coral%20tones%2C%20clean%20background%2C%20portrait%20composition&width=480&height=640&seq=cover-heart-02&orientation=portrait',
    description: '打工人姜娜娜的深夜便利店，总会出现一位每天只买同一种牛奶的神秘男生。一次停电的意外相遇，让两个陌生人的生活悄然交集。生活的琐碎里，藏着最动人的心动。',
    tags: ['日常', '治愈', '双向暗恋'],
    chapters: 96,
    likes: 76541,
  },
  {
    id: 'city-ability-agent',
    title: '都市异能特工',
    category: '动作',
    categoryKey: 'action',
    author: '李俊昊',
    status: '连载中',
    rating: 9.0,
    views: '1520万',
    cover: 'https://readdy.ai/api/search-image?query=Action%20packed%20Korean%20manhwa%20cover%2C%20a%20confident%20male%20agent%20in%20a%20black%20tactical%20suit%20with%20electric%20energy%20around%20his%20fist%2C%20city%20skyline%20behind%2C%20dramatic%20warm%20red%20and%20amber%20lighting%2C%20dynamic%20pose%2C%20clean%20background%2C%20high%20detail%20digital%20painting%2C%20portrait%20composition&width=480&height=640&seq=cover-city-03&orientation=portrait',
    description: '平凡快递员郑载民在一次袭击中觉醒了超能力，被招募进隐秘的特工组织。面对隐藏在都市阴影中的超能力犯罪集团，他一边隐瞒身份，一边守护身边的普通人。',
    tags: ['异能', '热血', '都市', '战斗'],
    chapters: 178,
    likes: 110320,
  },
  {
    id: 'transfer-secret',
    title: '转学后的秘密',
    category: '校园',
    categoryKey: 'campus',
    author: '韩瑞妍',
    status: '已完结',
    rating: 8.8,
    views: '742万',
    cover: 'https://readdy.ai/api/search-image?query=Youthful%20anime%20Korean%20manhwa%20cover%2C%20a%20new%20student%20with%20a%20backpack%20standing%20at%20a%20bright%20school%20gate%2C%20cherry%20blossom%20trees%20and%20a%20mysterious%20figure%20watching%2C%20fresh%20morning%20light%2C%20clean%20soft%20background%2C%20warm%20tone%2C%20portrait%20composition&width=480&height=640&seq=cover-transfer-04&orientation=portrait',
    description: '转学生尹书妍来到陌生的星川高中，却发现这里流传着一个无人敢提起的传说。随着她一步步接近真相，隐藏多年的秘密也开始浮出水面。青春的外表下，是一场温柔的冒险。',
    tags: ['青春', '成长', '校园谜团'],
    chapters: 85,
    likes: 52340,
  },
  {
    id: 'mist-chase',
    title: '迷雾追凶',
    category: '悬疑',
    categoryKey: 'mystery',
    author: '崔载赫',
    status: '连载中',
    rating: 9.3,
    views: '1330万',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20moody%20anime%20Korean%20manhwa%20cover%2C%20a%20detective%20holding%20a%20torch%20in%20dense%20fog%20near%20a%20silhouetted%20city%20bridge%2C%20cold%20teal%20and%20deep%20amber%20tones%2C%20suspenseful%20atmosphere%2C%20high%20contrast%2C%20clean%20composition%2C%20portrait%20composition&width=480&height=640&seq=cover-mist-05&orientation=portrait',
    description: '刑警宋旻浩在调查一桩连环失踪案时，发现所有线索都指向十年前的旧案。迷雾越深，真相越近，而他身边最信任的人，或许才是最大的谜题。',
    tags: ['刑侦', '推理', '反转', '心理'],
    chapters: 110,
    likes: 87210,
  },
  {
    id: 'starry-promise',
    title: '星夜之约',
    category: '爱情',
    categoryKey: 'love',
    author: '郑素敏',
    status: '连载中',
    rating: 9.0,
    views: '856万',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20Korean%20manhwa%20cover%2C%20a%20couple%20standing%20on%20a%20rooftop%20under%20a%20starlit%20night%20sky%2C%20city%20lights%20below%2C%20soft%20purple%20and%20warm%20gold%20sky%2C%20gentle%20romantic%20mood%2C%20clean%20background%2C%20high%20detail%20digital%20painting%2C%20portrait%20composition&width=480&height=640&seq=cover-star-06&orientation=portrait',
    description: '天文社社长李知勋和摄影社的姜夏，因为一场流星雨观测活动相识。两个人的约定，从夏夜延伸到四季。在繁忙的学业与生活里，他们成为彼此最亮的那颗星。',
    tags: ['甜宠', '校园', '青春'],
    chapters: 72,
    likes: 64890,
  },
  {
    id: 'demon-hunter-diary',
    title: '猎魔者日记',
    category: '奇幻',
    categoryKey: 'fantasy',
    author: '吴世勋',
    status: '连载中',
    rating: 9.2,
    views: '1170万',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20dark%20anime%20Korean%20manhwa%20cover%2C%20a%20young%20hunter%20in%20flowing%20robes%20wielding%20a%20glowing%20blade%20against%20shadowy%20demons%2C%20embers%20and%20magical%20fire%20in%20the%20air%2C%20dramatic%20dark%20red%20and%20gold%20tones%2C%20clean%20composition%2C%20portrait%20composition&width=480&height=640&seq=cover-demon-07&orientation=portrait',
    description: '继承了猎魔血脉的少年罗成，被封印的记忆逐渐苏醒。他背着双刀行走在人魔两界之间，却发现真正的敌人，远比传说中更加可怕。',
    tags: ['魔幻', '热血', '猎魔', '冒险'],
    chapters: 156,
    likes: 94530,
  },
  {
    id: 'seven-seconds',
    title: '倒数七秒',
    category: '悬疑',
    categoryKey: 'mystery',
    author: '金敏俊',
    status: '已完结',
    rating: 9.5,
    views: '1680万',
    cover: 'https://readdy.ai/api/search-image?query=Thriller%20anime%20Korean%20manhwa%20cover%2C%20a%20close%20up%20of%20a%20clock%20and%20an%20intense%20young%20mans%20eyes%2C%20dark%20conceptual%20background%20with%20faint%20digital%20numbers%2C%20high%20contrast%20teal%20and%20charcoal%2C%20tense%20mysterious%20mood%2C%20clean%20composition%2C%20portrait%20composition&width=480&height=640&seq=cover-seven-08&orientation=portrait',
    description: '游戏主播裴秀彬意外获得看穿"未来七秒"的能力。每一次预知都让他离真相更近一步，却也把危险引向身边最重要的人。他能否在命运倒计时结束前，改写所有人的结局？',
    tags: ['超能力', '烧脑', '时间', '反转'],
    chapters: 121,
    likes: 123450,
  },
  {
    id: 'spring-ballet',
    title: '春日芭蕾社',
    category: '校园',
    categoryKey: 'campus',
    author: '姜惠琳',
    status: '连载中',
    rating: 8.7,
    views: '603万',
    cover: 'https://readdy.ai/api/search-image?query=Soft%20anime%20Korean%20manhwa%20cover%2C%20a%20ballerina%20in%20a%20delicate%20dress%20standing%20in%20a%20sunlit%20studio%20with%20cherry%20petals%2C%20gentle%20pastel%20light%2C%20elegant%20graceful%20mood%2C%20clean%20background%2C%20portrait%20composition&width=480&height=640&seq=cover-ballet-09&orientation=portrait',
    description: '从小热爱芭蕾但被迫放弃梦想的女孩任秀雅，在转学后重拾舞鞋。她加入濒临解散的芭蕾社，与一群性格迥异的伙伴，一起为最后的舞台努力。',
    tags: ['梦想', '社团', '治愈'],
    chapters: 64,
    likes: 39870,
  },
  {
    id: 'dragon-blood',
    title: '龙血契约',
    category: '奇幻',
    categoryKey: 'fantasy',
    author: '许在东',
    status: '连载中',
    rating: 9.1,
    views: '1090万',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20anime%20Korean%20manhwa%20cover%2C%20a%20young%20warrior%20with%20glowing%20dragon%20scale%20armor%20standing%20before%20a%20huge%20dragon%20silhouette%2C%20golden%20and%20deep%20red%20energy%2C%20epic%20fantasy%20scale%2C%20clean%20background%2C%20high%20detail%20digital%20painting%2C%20portrait%20composition&width=480&height=640&seq=cover-dragon-10&orientation=portrait',
    description: '亡国遗孤李泽言体内流着世间最后的龙血。他从最底层的角斗场一路崛起，集结伙伴，向倾覆王国的黑暗势力宣战。血与火中，龙之王的传说重新苏醒。',
    tags: ['史诗', '龙', '复仇', '冒险'],
    chapters: 144,
    likes: 88920,
  },
  {
    id: 'seoul-lovers',
    title: '首尔恋人',
    category: '爱情',
    categoryKey: 'love',
    author: '林智秀',
    status: '已完结',
    rating: 9.2,
    views: '978万',
    cover: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20Korean%20manhwa%20cover%2C%20a%20fashionable%20couple%20walking%20in%20a%20neon%20lit%20Seoul%20street%20at%20night%2C%20umbrella%20and%20city%20lights%2C%20warm%20coral%20and%20deep%20blue%20night%20tones%2C%20clean%20romantic%20composition%2C%20portrait%20composition&width=480&height=640&seq=cover-seoul-11&orientation=portrait',
    description: '在首尔重逢的两位旧友，一个是广告公司的创意总监，一个是独立咖啡店主理人。十年前错过的遗憾，在无数次偶然相遇中被一点点填平。成年人的爱情，藏着更多克制与温柔。',
    tags: ['都市', '重逢', '成人爱情'],
    chapters: 98,
    likes: 70120,
  },
  {
    id: 'midnight-detective',
    title: '午夜侦探社',
    category: '悬疑',
    categoryKey: 'mystery',
    author: '黄东赫',
    status: '连载中',
    rating: 8.9,
    views: '820万',
    cover: 'https://readdy.ai/api/search-image?query=Noir%20anime%20Korean%20manhwa%20cover%2C%20a%20detective%20agency%20sign%20glowing%20at%20midnight%20in%20a%20rainy%20alley%2C%20a%20silhouetted%20investigator%20with%20a%20magnifying%20glass%2C%20cool%20teal%20and%20warm%20amber%20streetlights%2C%20mysterious%20noir%20mood%2C%20portrait%20composition&width=480&height=640&seq=cover-midnight-12&orientation=portrait',
    description: '只接受"午夜委托"的神秘侦探社，社长竟然是不问世事的漫画家。每一桩委托背后都藏着人性的秘密，而他记录下的故事，正是一个个反转迭起的谜案。',
    tags: ['单元剧', '推理', '人性'],
    chapters: 88,
    likes: 46780,
  },
  {
    id: 'genius-cook',
    title: '天才料理生',
    category: '校园',
    categoryKey: 'campus',
    author: '孙艺真',
    status: '连载中',
    rating: 8.6,
    views: '556万',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20anime%20Korean%20manhwa%20cover%2C%20a%20cheerful%20student%20chef%20in%20apron%20holding%20a%20cooking%20pan%20with%20steam%20and%20sparkles%2C%20colorful%20food%20ingredients%20around%2C%20warm%20yellow%20and%20cream%20tones%2C%20clean%20fun%20composition%2C%20portrait%20composition&width=480&height=640&seq=cover-cook-13&orientation=portrait',
    description: '从街边小摊走向顶级烹饪学校的少年朴太亨，用一道最简单的汤饭征服了所有评委。美食、友情与成长，在每一勺热气腾腾的料理里升温。',
    tags: ['美食', '励志', '校园'],
    chapters: 70,
    likes: 36520,
  },
  {
    id: 'divine-swordsman',
    title: '神域剑仙',
    category: '奇幻',
    categoryKey: 'fantasy',
    author: '郑雨盛',
    status: '连载中',
    rating: 9.3,
    views: '1410万',
    cover: 'https://readdy.ai/api/search-image?query=Wuxia%20fantasy%20anime%20Korean%20manhwa%20cover%2C%20a%20heroic%20swordsman%20in%20flowing%20white%20and%20gold%20robes%20leaping%20through%20clouds%20with%20a%20glowing%20sword%2C%20golden%20light%20and%20cherry%20blossoms%2C%20clean%20ethereal%20background%2C%20epic%20high%20detail%20digital%20painting%2C%20portrait%20composition&width=480&height=640&seq=cover-sword-14&orientation=portrait',
    description: '身负灭门之仇的少年萧辰，在绝境中觉醒剑心，踏上登临神域的修行之路。一剑破万法，问鼎九重天，他要用手中之剑，重写属于自己的命运。',
    tags: ['修仙', '剑道', '热血', '复仇'],
    chapters: 190,
    likes: 106780,
  },
  {
    id: 'bloody-king',
    title: '热血格斗王',
    category: '动作',
    categoryKey: 'action',
    author: '具本逸',
    status: '已完结',
    rating: 9.0,
    views: '1250万',
    cover: 'https://readdy.ai/api/search-image?query=High%20energy%20anime%20Korean%20manhwa%20cover%2C%20a%20muscular%20boxer%20in%20fighting%20stance%20inside%20a%20boxing%20ring%2C%20sweat%20and%20speed%20lines%2C%20warm%20red%20and%20amber%20spotlights%2C%20dynamic%20action%20mood%2C%20clean%20background%2C%20portrait%20composition&width=480&height=640&seq=cover-king-15&orientation=portrait',
    description: '曾经的天才拳手被一场败北打回谷底，从此隐姓埋名。为了守护弟弟的手术费，他重回擂台，向那个不可能战胜的对手发起最终挑战。',
    tags: ['格斗', '热血', '逆袭'],
    chapters: 105,
    likes: 83410,
  },
  {
    id: 'dim-light-is-you',
    title: '微光是你',
    category: '爱情',
    categoryKey: 'love',
    author: '沈银雅',
    status: '连载中',
    rating: 9.0,
    views: '915万',
    cover: 'https://readdy.ai/api/search-image?query=Soft%20glowing%20anime%20Korean%20manhwa%20cover%2C%20a%20girl%20holding%20a%20small%20lantern%20in%20a%20twilight%20meadow%20with%20fireflies%2C%20warm%20golden%20and%20coral%20light%2C%20gentle%20healing%20romantic%20mood%2C%20clean%20background%2C%20portrait%20composition&width=480&height=640&seq=cover-light-16&orientation=portrait',
    description: '失去声音的插画师柳星河，与患上面盲症的钢琴少年相遇。两个各有残缺的人，在无声与无色的世界里，为彼此点亮了唯一的微光。',
    tags: ['治愈', '双向救赎', '纯爱'],
    chapters: 66,
    likes: 55980,
  },
];

export function getComic(id: string) {
  return comics.find((c) => c.id === id);
}

export function getCategoryName(key: string) {
  const cat = categories.find((c) => c.key === key);
  return cat ? cat.name : '全部漫画';
}